// extracted by mini-css-extract-plugin
module.exports = {"grid":"Container_grid__24upy"};